import React, { useEffect, useState } from 'react';
import moment from 'moment';
import prettyMs from 'pretty-ms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { auctionType } from '../../types';
import './_styles_/AuctionCountdown.css';
import { date } from '../../utils';
import { getServerTimeOffset } from '../../reducers';

export const countMsToClose = (currentMoment, closureMoment, offsetInMs) => {
    const currentMomentInUtc = currentMoment.utc();
    const closureMomentInUtc = closureMoment.utc();
    const remainingMsToClose = closureMomentInUtc.diff(currentMomentInUtc) + offsetInMs;
    return remainingMsToClose < 0 ? 0 : remainingMsToClose;
};

const prettyMsOptions = {
    colonNotation: true,
    secondsDecimalDigits: 0,
};

AuctionCountdown.propTypes = {
    auction: auctionType.isRequired,
};

function AuctionCountdown(props) {
    const {
        auction,
    } = props;
    const { t } = useTranslation();
    const [closureMoment, setClosureMoment] = useState(moment(auction.closureTime));
    useEffect(() => {
        setClosureMoment(moment(auction.closureTime));
    }, [auction.closureTime]);
    const serverTimeOffsetInMs = useSelector(getServerTimeOffset);
    const [msToClose, setMsToClose] = useState(0);
    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setMsToClose(countMsToClose(moment(date()), closureMoment, serverTimeOffsetInMs));
        }, 1000);
        setMsToClose(countMsToClose(moment(date()), closureMoment, serverTimeOffsetInMs));
        return () => clearInterval(countdownInterval);
    }, [closureMoment, serverTimeOffsetInMs]);
    return (
        <div className="auction-header--progress--header--countdown">
            {
                msToClose
                    ? prettyMs(msToClose, prettyMsOptions)
                    : <><FontAwesomeIcon className="auction-countdown--wait-for-sync" icon="sync" spin /> {t('misc.syncing')}</>
            }
        </div>
    );
}

export default AuctionCountdown;
